"use client";
import React, { useState } from "react";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  // Toggle the Read More state
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  // rohailjohn
  return (
    <>
      <div
        className={`${isReadMore ? "line-clamp-5" : ""} overflow-hidden`}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
        }}
      >
        {/* {text} */}
        <p
          dangerouslySetInnerHTML={{ __html: text }}
          className="updatedparapremu pt-6"
        ></p>
      </div>
      {text.length > 380 && (
        <div
          onClick={toggleReadMore}
          className="style-redmore"
          style={{
            color: "#D5AF34",
            fontSize: "17px",
            display: "inline-block",
            marginLeft: "1px",
            cursor: "pointer",
          }}
        >
          {isReadMore ? "Read More" : "Show less"}
        </div>
      )}
    </>
  );
};

function thirdSlider({ Mydata }) {
  const data = Mydata[2];
  return (
    <div style={{ background: "rgba(213, 175, 52, 0.1)" }} className="px-4">
      <div className="mx-auto max-w-7xl pt-7 text-center ">
        <h2 className="text-4xl secondary  font-bold ">
          <span style={{ color: "#2B3252" }}>{data.title}</span>
          <span style={{ color: "#D5AF34" }}>{data.subtitle}</span>
        </h2>

        <div className="display">
          <p
            dangerouslySetInnerHTML={{ __html: data.des }}
            className="updatedparapremu display pt-6"
          ></p>
          {/* <p className="updatedparapremu pt-6">{data.des}</p> */}
        </div>

        <div className="display-desktop">
          <ReadMore maxLines={5}>{data.des}</ReadMore>
        </div>
        <div className="pb-7"></div>
      </div>
    </div>
  );
}

export default thirdSlider;
